import { render, staticRenderFns } from "./PublisherFileDelete.vue?vue&type=template&id=0db73ba1&scoped=true"
import script from "./PublisherFileDelete.vue?vue&type=script&lang=js"
export * from "./PublisherFileDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db73ba1",
  null
  
)

export default component.exports